import React from 'react';
import './ClinicalSummaryCard.css'; // Import the new, standalone stylesheet

const ClinicalSummaryCard = ({ variantIdentity, clinicalSignificance, oncoKbData, vepData, searchTerm }) => {
    // A robust check for all necessary data before rendering
    if (!variantIdentity || !clinicalSignificance?.length || !oncoKbData?.summary) {
        return (
            <div className="ONCRP-TOOLS-QP-span-col-6 ONCRP-TOOLS-QP-span-row-2">
                <div className="ONCRP-TOOLS-QP-summary-placeholder">
                    <span>Clinical summary data not available.</span>
                </div>
            </div>
        );
    }
    
    const { gene, alteration, rs_id } = variantIdentity;
    const { summary: oncoSummary } = oncoKbData;

    return (
        <div className="ONCRP-TOOLS-QP-span-col-6 ONCRP-TOOLS-QP-span-row-2">
            <div className="ONCRP-TOOLS-QP-card">
                <div className="ONCRP-TOOLS-QP-card-header ONCRP-TOOLS-QP-summary-card-header">
                    <div className="ONCRP-TOOLS-QP-header-left">
                        <i className="fa fa-file-medical-alt"></i>
                        <h3>Clinical Summary</h3>
                    </div>
                    {rs_id && <span className="ONCRP-TOOLS-QP-rsid-chip">{rs_id}</span>}
                </div>

                <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                    <div className="ONCRP-TOOLS-QP-card-body" style={{ flex: 3, borderRight: '1px solid rgba(255, 255, 255, 0.1)' }}>
                        <div className="ONCRP-TOOLS-QP-summary-hero-init">
                            <div className="ONCRP-TOOLS-QP-summary-hero">
                                <h1 className="ONCRP-TOOLS-QP-hero-title">{gene}</h1>
                                <h2 className="ONCRP-TOOLS-QP-hero-subtitle">{alteration}</h2>
                            </div>
                            <div className="ONCRP-TOOLS-QP-stats-container">
                                <div className="ONCRP-TOOLS-QP-stat">
                                    <div className="ONCRP-TOOLS-QP-stat-label">Oncogenicity</div>
                                    <div className="ONCRP-TOOLS-QP-stat-value">{oncoSummary.oncogenicity || 'N/A'}</div>
                                </div>
                                <div className="ONCRP-TOOLS-QP-stat">
                                    <div className="ONCRP-TOOLS-QP-stat-label">Mutation Effect</div>
                                    <div className="ONCRP-TOOLS-QP-stat-value">{oncoSummary.mutationEffect || 'N/A'}</div>
                                </div>
                            </div>
                        </div>

                        {/* --- CONTEXT & SIGNIFICANCE --- */}
                        <div className="ONCRP-TOOLS-QP-details-section">
                            <h4 className="ONCRP-TOOLS-QP-details-title">Variant Context</h4>
                            <p className="ONCRP-TOOLS-QP-details-text">{oncoSummary.variantSummary || 'No variant summary available.'}</p>
                        </div>
                        <hr className="ONCRP-TOOLS-QP-summary-divider" />
                        <div className="ONCRP-TOOLS-QP-details-section">
                            <h4 className="ONCRP-TOOLS-QP-details-title">Reported Significance</h4>
                            <div className="ONCRP-TOOLS-QP-significance-tags-container">
                                {clinicalSignificance.map((sig, i) => (
                                    <span key={i} className="ONCRP-TOOLS-QP-significance-tag">
                                        <strong>{sig.source}:</strong> {sig.value}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="ONCRP-TOOLS-QP-card-body" style={{ flex: 1 }}>
                        {vepData && (
                            <div className="ONCRP-TOOLS-QP-details-section">
                                <h4 className="ONCRP-TOOLS-QP-details-title">Variant Identity</h4>
                                <div className="ONCRP-TOOLS-QP-variant-identity-grid">
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">VEP ID:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.id || 'N/A'}</span>
                                    </div>
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">Assembly:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.assembly_name || 'N/A'}</span>
                                    </div>
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">Locus:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.seq_region_name && vepData.start ? `${vepData.seq_region_name}:${vepData.start}` : 'N/A'}</span>
                                    </div>
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">Allele String:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.allele_string || 'N/A'}</span>
                                    </div>
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">Variant Class:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.variant_class || 'N/A'}</span>
                                    </div>
                                    <div className="ONCRP-TOOLS-QP-identity-item">
                                        <span className="ONCRP-TOOLS-QP-identity-label">Strand:</span>
                                        <span className="ONCRP-TOOLS-QP-identity-value">{vepData.strand || 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClinicalSummaryCard;